var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealPageLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_37)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 0.994286,
    fill: "#EE7755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.00814C12 6.11682 11.1043 7.01629 9.99937 7.01629C8.89445 7.01629 7.99999 6.11682 7.99999 5.00814C7.99999 3.89947 8.8957 3 10.0006 3C11.1043 3 12 3.89947 12 5.00814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 14C6.99999 15.1042 6.10428 16 4.99937 16C3.89445 16 2.99999 15.1042 2.99999 14C2.99999 12.8958 3.8957 12 5.00062 12C6.10554 12 6.99999 12.8946 6.99999 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 14C17 15.1042 16.1043 16 14.9994 16C13.8957 16 13 15.1042 13 14C13 12.8958 13.8957 12 14.9994 12C16.1055 12 17 12.8946 17 14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealPageLogoSmall);
export default __webpack_public_path__ + "static/media/real-page-logo-small.cc50ecfa.svg";
export { ForwardRef as ReactComponent };